// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Star(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Star" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M12 2L14.3607 9.25735H22L15.8197 13.7426L18.1803 21L12 16.5147L5.81966 21L8.18034 13.7426L2 9.25735H9.63932L12 2Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Star.js.map